export default __webpack_public_path__ + "static/superset-34e3cecee85a5c4ae6fd1ff8ff5a71f5.png";